import axios from "axios";

interface UpdatedProfileValues {
  phone: string;
  image?: string;
}

export const getMe = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Error("No token found");
  }

  try {
    const response = await axios.get(`${process.env.REACT_APP_URL}/me/`, {
      headers: { Authorization: `Bearer ${token}`, "X-Client-Type": "web" },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateProfile = async (values: UpdatedProfileValues) => {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Error("No token found");
  }

  const requestBody = {
    phone: values.phone,
    image: values.image,
  };

  try {
    const response = await axios.put(
      `${process.env.REACT_APP_URL}/me`,
      requestBody,
      {
        headers: { Authorization: `Bearer ${token}`, "X-Client-Type": "web" },
      }
    );
    return response.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error("Update failed: " + error.message);
    } else {
      throw new Error("Unknown error occurred during update.");
    }
  }
};
